var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.77778 18.2222H7.04444L15.7333 9.53333L14.4667 8.26667L5.77778 16.9556V18.2222ZM4.88889 20C4.63704 20 4.42593 19.9148 4.25556 19.7444C4.08519 19.5741 4 19.363 4 19.1111V16.9556C4 16.7185 4.04444 16.4926 4.13333 16.2778C4.22222 16.063 4.34815 15.8741 4.51111 15.7111L15.7333 4.51111C15.9111 4.34815 16.1074 4.22222 16.3222 4.13333C16.537 4.04444 16.763 4 17 4C17.237 4 17.4667 4.04444 17.6889 4.13333C17.9111 4.22222 18.1037 4.35556 18.2667 4.53333L19.4889 5.77778C19.6667 5.94074 19.7963 6.13333 19.8778 6.35556C19.9593 6.57778 20 6.8 20 7.02222C20 7.25926 19.9593 7.48519 19.8778 7.7C19.7963 7.91481 19.6667 8.11111 19.4889 8.28889L8.28889 19.4889C8.12593 19.6519 7.93704 19.7778 7.72222 19.8667C7.50741 19.9556 7.28148 20 7.04444 20H4.88889ZM15.0889 8.91111L14.4667 8.26667L15.7333 9.53333L15.0889 8.91111Z",
    fill: "#6158D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.db6eb5b2b0242c1608daf9295ae919b2.svg";
export { ForwardRef as ReactComponent };